import { useRef, useState } from 'react';
import { SwapSet, copySwapSet, isValidSet } from './swaps.domain';

type DraftSet = SwapSet & { key: number };

export const useDraftSets = (initial: SwapSet[]) => {
  const nextKey = useRef(0);
  const [sets, setSets] = useState<DraftSet[]>(() =>
    initial.map((set) => ({ ...copySwapSet(set), key: nextKey.current++ })),
  );

  const updateSet = (key: number, set: SwapSet) =>
    setSets((current) =>
      current.map((draft) => (draft.key === key ? { ...set, key } : draft)),
    );
  const setUnit = (unit: string) =>
    setSets((current) =>
      current.map((draft) => ({ ...draft, reps: [draft.reps[0], unit] })),
    );
  const addSet = () =>
    setSets((current) => [
      ...current,
      {
        key: nextKey.current++,
        reps: [0, current[0]?.reps[1] ?? 'reps'],
        mode: 'fixed',
      },
    ]);
  const removeSet = (key: number) =>
    setSets((current) => current.filter((set) => set.key !== key));

  return {
    sets,
    valid: sets.every(isValidSet),
    updateSet,
    setUnit,
    addSet,
    removeSet,
    toSwapSets: (): SwapSet[] => sets.map(copySwapSet),
  };
};
